import React,{useEffect, useState} from 'react';
import styles from "../../styles/components/emptwinCart.module.scss";
import endpoints from "../../utility/endpoints";
import axios from "axios";
import router from 'next/router';
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../redux/global/actions.js";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UploadFileComponent from "../uploadFileemptwin";
import Icons from "../../public/assets/svg";
import _get from "lodash/get";
import { BlobServiceClient } from "@azure/storage-blob";
export default function index(props) {
  document.body.style.overflow = "auto";
const empid = JSON.parse(localStorage.getItem('empid'));
const goTo = (link) => {
  router.push(link);
};
const [localskill, setLocalskill] = useState([]);
const [globalskill, setGlobalskill] = useState([]);
const [softskill, setSoftskill] = useState([]);
const [localskilldata, setLocalskilldata] = useState([]);
const [globalskilldata, setGlobalskilldata] = useState([]);
const [softskilldata, setSoftskilldata] = useState([]);
const [products, setProducts] = useState([]);
const [ETname, setETname] = useState("");
const [Etprofile, setEtprofile] = useState("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/etdefault.jpg");
const [fileTypesp, setfileTypesp] = useState([
  "jpg",
  "jpeg",
  "png",
 ]);
// const [fileError, setError] = useState(false);
 const [fileerror, setFileError] = useState(false);	
  const [filesuccess, setFilesuccess] = useState(false);	
   const [submitForm, setSubmitForm] = React.useState(false);	
    const [option, setoption] = useState(["Mimi","Aakartest","Aarambhtest"]);	
  const [optionname, setoptionname] = useState([]);
  const [file, setFile] = useState(null);
  const [fileNameOriginal, setFileName] = useState(null);
  const [showFileName, setShowFileName] = useState(false);

/*add Extra Local skill*/

/*end add Extra Local skill*/
const localHandler = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/localSkill?empTwinId=${empid}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },

    });
 
    if (data.code === 200) {
      setLocalskill(data.data);
    }
    else
    {
      console.log("No data found")
    }
  
}
const globalHandler = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/purchasecartTwin`,
    method: "POST",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data:{
      employeeTwinID:empid,
      businessRequest:`${auth.email}`,
    }

  });
  //console.log(data);
  if (data.code === 200) {
    setGlobalskill(data.GlobalSkill);
    setLocalskill(data.LocalSkill);
    setSoftskill(data.softSkill);
    // const botIDs = localskill.map((item) => item.botID);
    // const processNames = localskill.map((item) => item.processName);
   
  
  }
  else
  {
    console.log("No data found")
  }

}
const softHandler = async (e) => {

  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } = await axios({
    url: `${endpoints.baseUrl}/softSkill/search?empTwinId=${empid}`,
    method: "GET",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },

  });
 
  if (data.code === 200) {
    setSoftskill(data.data);

  }
  else
  {
    console.log("No data found")
  }

}
const deletelocalskill= botExternalId =>{
  //console.log(botExternalId);
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } =  axios({
    url: `${endpoints.baseUrl}/twin/localSkill/deletepurchaseCart`,
    method: "DELETE",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data: {
      businessRequest:`${auth.email}`,
      skillID:botExternalId
    },

  }).then((resp) => {

  //console.log(resp);
  if (resp.data.code === 200) {
    setLocalskill(oldValues => {
    return oldValues.filter(localskill => localskill!== botExternalId)
    })

  }
  else
  {
    console.log("No data found")
  }
})
}
const deleteglobalskill= botExternalId =>{
  //console.log(botExternalId);
  //console.log(empid);
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } =  axios({
    url: `${endpoints.baseUrl}/twin/globalSkill/deletepurchaseCart`,
    method: "DELETE",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data: {
      businessRequest:`${auth.email}`,
      skillID:botExternalId
    },

  }).then((resp) => {

  //console.log(resp);
  if (resp.data.code === 200) {
    setGlobalskill(oldValues => {
    return oldValues.filter(globalskill => globalskill!== botExternalId)
    })

  }
  else
  {
    console.log("No data found")
  }
})
}
const deletesoftskill= softSkillID =>{
  //console.log(softSkillID);
  //console.log(softSkillID);
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } =  axios({
    url: `${endpoints.baseUrl}/twin/softSkill/deletepurchaseCart`,
    method: "DELETE",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data: {
      businessRequest:`${auth.email}`,
      skillID:softSkillID
    },

  }).then((resp) => {

  //console.log(resp);
  if (resp.data.code === 200) {
    setSoftskill(oldValues => {
    return oldValues.filter(softskill => softskill!== softSkillID)
    })

  }
  else
  {
    console.log("No data found")
  }
})
}

const onValueChange = async (e) => {
  const value = e.target.value;
  console.log(e.target.id,e.target.value)
if (e.target.id=="etname"){
  setETname(e.target.value);
}
}
let azurefilepath;
const blobSasUrl =
"https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2021-04-02T10:26:05Z&st=2021-03-02T02:26:05Z&spr=https&sig=v7MtaG5GbZX7NyzUpshCkd61ouluKHob5uram7ip9eM%3D";

const blobSasUrlNew = endpoints.blobSasUrlNew;
// "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";
const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

const containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");

const uploadFile = async  (imageFile) => {
  {/*console.log(file.name, "pdfsauto");
  azurefilepath= "https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp"+file.name;
  console.log("azure file path",azurefilepath)
  setFile(file);
  setShowFileName(true);
  setFileName(file.name);*/}
const originalFileName = imageFile.name;	
    let fileName = originalFileName;	
    let index = 1;	
    // Check if the file name already exists in the container	
    while (await containerClient.getBlockBlobClient(fileName).exists()) {	
      const extension = originalFileName.substring(originalFileName.lastIndexOf('.'));	
      fileName = `${originalFileName.substring(0, originalFileName.lastIndexOf('.'))}_${index}${extension}`;	
      index++;	
    }	
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);	
    try {	
      await blockBlobClient.uploadBrowserData(imageFile);	
      console.log('Image uploaded successfully!');	
       setEtprofile("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+fileName)	
      setFilesuccess(true);	
    } catch (error) {	
     setFileError(true);	
      console.error('Error uploading image:', error);	
    }
};

const uploadButtonClick = async () => {
  //console.log(fileNameOriginal, "fileName", file);

  let fileNameWithSpaces = fileNameOriginal;
  let fileName = fileNameWithSpaces.replace(/ /g, "");
  let ar = fileNameOriginal.split(".");
  let extension = ar[ar.length - 1];
  const fileSize = file.size;

  try {
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);
    const options = { blobHTTPHeaders: { blobContentType: file.type } };
    const resp = await blockBlobClient.uploadBrowserData(file, options);
    console.log(resp, "response of azure");
    let url = resp._response.request.url;
    setSuccessModal(true);
  } catch (error) {
    console.log(error, "erro");
    alert("Could not upload");
  }
};
const onFromSubmit = async () => {

  let authCheck = JSON.parse(localStorage.getItem("auth")).data;
  	    if(ETname==""){	
    setSubmitForm(true);	
  }	
  else{
        let auth = await JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "post",
          url: `${endpoints.baseUrl}/twin/employee_order`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data: {
            "orderID":"",
            businessRequest:`${auth.email}`,
            globalSkill:globalid.join(','),
            localSkill:localid.join(','),
            softSkill:softid.join(','),
            product_id:productid.join(','),
            GlobalSkill_ProcessName:GlobalSkill_ProcessName.join(','),
            localSkill_ProcessName:localSkill_ProcessName.join(','),
            softSkill_ProcessName:softSkill_ProcessName.join(','),
            productSkill_ProcessName:productSkill_ProcessName.join(','),
            ETname:ETname,
            Etprofile:Etprofile,
          },
        }).then((resp) => {
          if (resp.data.code == 403) {
            setLoading(false)
           
          } 
          else if (resp.status == 200) {
            //console.log(resp.data);
            localStorage.setItem('orderid', JSON.stringify(resp.data.data.orderID));
            localStorage.setItem('livedate', JSON.stringify(resp.data.data.goLiveDate));
            // console.log(resp.data);
//           emailHandler();    
           router.push(props.pageRoutes.Order);
            
          } 
          else if (resp.data.code == 400) {
          
          }
        });
      
    }

};
{/*const emailHandler = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const orderiddd = JSON.parse(localStorage.getItem('orderid'));

  const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/orderMail`,
    method: "POST",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data:{
      orderID:orderiddd,
    }

  });
  //console.log("mail data",data);
  if (data.code === 200) {
 //   setGlobalskill(data.GlobalSkill);
   // setLocalskill(data.LocalSkill);
    //setSoftskill(data.softSkill);

  
  }
  else
  {
    console.log("No data found")
  }

}*/}
const deleteproduct= product_id =>{
  //console.log(product_id);
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } =  axios({
    url: `${endpoints.baseUrl}/twin/product/deletepurchaseCart`,
    method: "DELETE",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data: {
      businessRequest:`${auth.email}`,
      skillID:product_id
    },

  }).then((resp) => {

  //console.log(resp);
  if (resp.data.code === 200) {
    setProducts(oldValues => {
    return oldValues.filter(products => products!== product_id)
    })

  }
  else
  {
    console.log("No data found")
  }
})
}
const productHandler = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  //console.log(`${auth.email}`);
          const { data } = await axios({
            url: `${endpoints.baseUrl}/twin/getProductCart`,
            method: "POST",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data:{
              businessRequest:`${auth.email}`,
            }
          });
        //console.log(data);
          if (data.code === 200) {
            setProducts(data.data);
          }
          else
          {
            console.log("No data found")
          }
        
      }
const [twinname,settwinname]=useState([]);	
      const twinHandler = async (e) => {	
        let auth = JSON.parse(localStorage.getItem("auth")).data;	
        const { data } = await axios({	
          url: `${endpoints.baseUrl}/twin/getTwinname`,	
          method: "GET",	
          headers: {	
            Authorization: `${auth.accessToken}|${auth.email}`,	
          },	
    	
        });	
     	
        if (data.code === 200) {	
          const nonEmptyValues = data.data.filter((value) => value !== '');	
          settwinname(nonEmptyValues);	
          const uniqueArray = [	
            ...option.filter((element) => !nonEmptyValues.includes(element)),	
            ...nonEmptyValues.filter((element) => !option.includes(element))	
          ];	
          setoptionname(uniqueArray);	
        }	
        else	
        {	
          console.log("No data found")	
        }	
      	
    }	
    React.useEffect(() => {	
      twinHandler();	
    },[twinname])
React.useEffect(() => {
  productHandler();
},[products]);
// React.useEffect(() => {
//   localHandler();
// },[localskill]);
React.useEffect(() => {
  globalHandler();
},[globalskill])
// React.useEffect(() => {
//   softHandler();
// },[softskill])

const globalid=globalskill.map((item, index) => {
  return item.botExternalId
})
const localid=localskill.map((item, index) => {
  return item.botExternalId
})
const softid=softskill.map((item, index) => {
  return item.softSkillID
})

const productid=products.map((item, index) => {
  return item.product_id
})

const GlobalSkill_ProcessName=globalskill.map((item, index) => {
  return item.processName
})
const localSkill_ProcessName=localskill.map((item, index) => {
  return item.processName
})
const softSkill_ProcessName=softskill.map((item, index) => {
  return item.skillName
})

const productSkill_ProcessName=products.map((item, index) => {
  return item.product_title
})
 const handleFileChange = (event) => {	
    const file = event.target.files[0];	
    if (file) {	
      uploadFile(file);	
    }	
  };

    return (
        <div className={`${styles.emptwinbannerWrapper1} container`}>

                <div className={`${styles.row} row pb-4` }>
                    
                    <div class="col-lg-12 col-md-12 col-12 pt-4">
                        <table className={styles.tableskill} cellSpacing="10">
                        
                            <tr className={styles.bottext1}>
                                <td><h2 className={styles.heading}>My Automation Bag</h2></td>
                                <td> <h2  className={styles.heading}>1 Item</h2></td>
                            </tr>
                            <tr className={styles.bottext2}>
                                <td ><p className={styles.text}>Bot Product</p></td>
                                <td><p className={styles.text}>Action</p></td>
                            </tr>
                            <tr className={styles.skilllist}>
                                <td className={styles.firsttd}>
                                    <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/soft.png"/>
                                    <h3 className={styles.skillheading}>Soft Skills 
                                    {softskill.map((item, index) => {
                                        const {
                                            softSkillID,
                                            skillName,
                                            category
                                        } = item;
                                        return(<p className={`${styles.skillslisttext}`} id={softSkillID}>{skillName} <span className="remove" onClick={()=>{deletesoftskill(softSkillID)}}>🗙</span></p>)
                                    
                                    })}
                                    </h3>
                                </td>
                               
                                {/* <td><img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/trash.png"/></td> */}
                                
                            </tr>
                            <tr className={styles.skilllist}>
                                <td className={styles.firsttd}>
                                   <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/global.png"/>
                                   <h3 className={styles.skillheading}>Global Skills 
                                    {globalskill.map((item, index) => {
                                        const {
                                            botExternalId,
                                            processName,
                                        } = item;
                                        return(<p className={`${styles.skillslisttext}`} id={botExternalId}>{processName} <span className="remove" onClick={()=>{deleteglobalskill(botExternalId)}}>🗙</span></p>)
                                    
                                    })}
                                    {products.map((item, index) => {
                                        const {
                                          product_id,
                                          product_title,
                                          lead_platform,
                                          subarea
                                        } = item;
                                        return(<p className={`${styles.skillslisttext}`} id={product_id}>{product_title} <span className="remove" onClick={()=>{deleteproduct(product_id)}}>🗙</span></p>)
                                    
                                    })}
                                    </h3>
                                </td>
                               
                                {/* <td><img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/trash.png"/></td> */}
                            </tr>
                            <tr className={styles.skilllist}>
                                <td className={styles.firsttd}>
                                <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/local.png"/>
                                <h3 className={styles.skillheading}>Local Skills 
                                    {localskill.map((item, index) => {
                                        const {
                                            botExternalId,
                                            processName,
                                        } = item;
                                        return(<p className={`${styles.skillslisttext}`} id={botExternalId}>{processName} <span className="remove" onClick={()=>{deletelocalskill(botExternalId)}}>🗙</span></p>)
                                    
                                    })}
                                    </h3>
                                </td>
                                {/* <td><img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/trash.png"/></td> */}
                            </tr>
                                                      <tr  className={styles.skilllist}>
                              
                              <td style={{width:"50%"}}>	
              <div className="col-lg-12 col-md-12 col-12">	
                <div className={styles.formGroup}>	
                  <div className={`${styles.uploadBtnWrapper}`}>	
                    <div className={styles.uploadFileContainer}>	
                      <label className={styles.mainLabel}>	
                        Employee Twin Name	
                  <sup className={styles.mandatoryField}>*</sup>	
                      {submitForm?	
                   	
                    <span className={styles.errorMessage}>	
                      Please Choose Employee Twin Name	
                    </span>:null	
                  }	
                      </label>                       	
       <select className={styles.select} id="etname" name="etname" 	
                                    onChange={onValueChange}>	
                                    <option defaultValue> Choose Your Employee Twin Name</option>	
                                    {optionname.map((item)=>{	
                          return(<option value={item}>{item}</option>)	
                        })}	
                              </select>	
                              </div>	
                  </div>	
                </div>	
              </div>                            
  </td>
    <td  style={{width:"50%"}}>	
                              <div className="col-lg-12 col-md-12 col-12">	
              <div className={styles.formGroup}>	
              	
                <div className={`${styles.uploadBtnWrapper}`}>	
                  <div className={styles.uploadFileContainer}>	
                  <label className={styles.mainLabel}>	
                    Upload Profile	
                    {filesuccess ? (	
                          <span style={{ color: "#00b190", fontSize: "12px" }}>	
                            Uploaded Successfully	
                          </span>	
                        ) : null}	
                        {fileerror ? (	
                          <span style={{ color: "red", fontSize: "12px" }}>	
                            Error when uploading	
                          </span>	
                        ) : null}	
                 	
 </label>	
                     <div className={styles.uploadControl}>	
                  <input type="file" onChange={(e)=>{handleFileChange(e)}} className={styles.fileupload}/>	
                {/*  <div className={styles.uploadControl}>	
             	
                <UploadFileComponent	
                  type="frameworkss"	
                  fileType={fileTypesp}	
                  uploadFile={uploadFile}	
                  uploaded={showFileName}	
                  value="frameworkDocumentss"	
                />	
               	
             	
              <div className={styles.actionBtn} onClick={uploadButtonClick}>	
                <span>	
                  <Icons	
                    name="uploadicon"	
                    className={styles.uploadIcon}	
                  ></Icons>	
                 Upload File	
                </span>	
              </div> 	
              	
            </div>*/}	
                  </div>	
                 </div>	
                </div>	
              </div>	
            </div>	
                              </td>	               
             

                            </tr>
                            <tr styles={{height:"100px"}}>
                            <td><img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/back.png"  onClick={() => goTo(props.pageRoutes.Purchaseemployeetwin)}/></td>
                             <td> <button className={styles.submitbtn}  onClick={onFromSubmit}>Submit</button></td>
                            </tr>
                       </table>
                       
                    </div>
                    
                   
                    </div>
           

        </div>
        
    )
}
